export default function (torchlight, options) {
  torchlight.cache.clear()
}
